<tds-modal size="md" closeIconButtonLabel="Close">
    <tds-modal-title>Request hourly data</tds-modal-title>

    <form [formGroup]="hourlyDataRequestForm" class="hourly-data-form">
      <div class="hourly-data-fields">
        <tds-form-field class="hourly-data-field">
          <tds-form-field-label>Price zone</tds-form-field-label>
          <tds-dropdown tds-form-field-item formControlName="zone" [items]="regionsOptions()">
            Select a zone
          </tds-dropdown>
        </tds-form-field>

        <tds-form-field class="hourly-data-field">
          <tds-form-field-label>Source</tds-form-field-label>
          <tds-dropdown tds-form-field-item formControlName="source" [items]="sourcesOptions()">
            Select a source
          </tds-dropdown>
        </tds-form-field>

        <tds-form-field class="hourly-data-field">
          <tds-form-field-label>Basecase</tds-form-field-label>
          <tds-dropdown tds-form-field-item formControlName="basecase" [items]="basecasesOptions()">
            Select a basecase
          </tds-dropdown>
        </tds-form-field>
      </div>

      <fieldset tds-fieldset class="hourly-data-reason-toggle">
        <tds-fieldset-label>Reason</tds-fieldset-label>
        <tds-radio>
          <input tds-radio-input type="radio" name="reasonType" formControlName="reasonType" value="specific" />
          <span tds-radio-label>Specific reason(s)</span>
        </tds-radio>
        <tds-radio>
          <input tds-radio-input type="radio" name="reasonType" formControlName="reasonType" value="other" />
          <span tds-radio-label>Other reason</span>
        </tds-radio>
      </fieldset>

      @if (isSpecificReason()) {
        <mat-form-field appearance="outline" class="hourly-data-field">
          <mat-label>Specific reason(s)</mat-label>
          <mat-select multiple formControlName="specificReason">
            <mat-select-trigger class="hourly-data-reason-tags">
              @for (reason of hourlyDataRequestForm.controls.specificReason.value; track reason) {
                <tds-tag isClosable closeIconButtonLabel="Remove reason" (close)="removeSpecificReason(reason, $event)">
                  {{ specificReasonLabel(reason) }}
                </tds-tag>
              }
            </mat-select-trigger>
            @for (option of specificReasonOptions; track option.value) {
              <mat-option [value]="option.value">{{ option.label }}</mat-option>
            }
          </mat-select>
        </mat-form-field>

        <!-- specific-reason branch -->
<tds-form-field class="hourly-data-field">
  <tds-form-field-label>Comments / Business Project / Investment file</tds-form-field-label>
  <textarea tds-form-field-item class="hourly-data-textarea" formControlName="comment" rows="3" placeholder="Add a comment" required></textarea>
</tds-form-field>
      } @else {
        @if (!isWeatherYearHidden()) {
        <mat-form-field appearance="outline" class="hourly-data-field">
          <mat-label>Weather year</mat-label>
          <mat-select multiple formControlName="weatherYears">
            <mat-select-trigger class="hourly-data-reason-tags">
              @for (weatherYearId of hourlyDataRequestForm.controls.weatherYears.value; track weatherYearId) {
                <tds-tag isClosable closeIconButtonLabel="Remove weather year" (close)="removeWeatherYear(weatherYearId, $event)">
                  {{ weatherYearLabel(weatherYearId) }}
                </tds-tag>
              }
            </mat-select-trigger>
            @for (option of weatherYearsOptions(); track option.value) {
              <mat-option [value]="option.value">{{ option.label }}</mat-option>
            }
          </mat-select>
        </mat-form-field>
        }

        <div class="hourly-data-fields">
          <tds-form-field class="hourly-data-field">
            <tds-form-field-label>Year from</tds-form-field-label>
            <input tds-form-field-item type="number" formControlName="yearsStart" placeholder="e.g. 2026" required />
          </tds-form-field>

          <tds-form-field class="hourly-data-field">
            <tds-form-field-label>Year to</tds-form-field-label>
            <input tds-form-field-item type="number" formControlName="yearsEnd" placeholder="e.g. 2026" required />
          </tds-form-field>
        </div>

        <!-- other-reason branch -->
<tds-form-field class="hourly-data-field">
  <tds-form-field-label>Other reason</tds-form-field-label>
  <textarea tds-form-field-item class="hourly-data-textarea" formControlName="comment" rows="3" placeholder="Describe the reason" required></textarea>
</tds-form-field>
      }
    </form>

    <tds-modal-actions>
      <button tds-button variant="tertiary" (click)="close('cancel')" (keyup)="close('cancel')">Cancel</button>
      <button tds-button [disabled]="hourlyDataRequestForm.invalid" (click)="save()" (keyup)="save()">Save</button>
    </tds-modal-actions>
  </tds-modal>